import React, { FC } from 'react'
import ReactQuill from 'react-quill'
import { useController } from 'react-hook-form'

import { QuillFormProps } from './QuillForm.props'

const QuillForm: FC<QuillFormProps> = ({ fieldName, control, className, label, toolbarModules }) => {
  const { field } = useController({
    name: fieldName,
    control
  })

  return (
    <section className={className}>
      <h3 className={`${className}__title`}>{label}</h3>
      <ReactQuill
        theme="snow"
        value={field.value}
        onChange={(date: string) => field.onChange(date)}
        modules={toolbarModules}
      />
    </section>
  )
}

export default QuillForm
